import HighlightMessage from './HighlightMessage';
import { HighlightMessageProps, HighlightMessageValueProps } from './types';

export type { HighlightMessageProps, HighlightMessageValueProps };
export default HighlightMessage;
